import { motion } from "framer-motion";

const steps = [
  {
    num: "01",
    title: "Build Your Profile",
    description: "Tell us about your sport, experience, goals, and mental challenges. This becomes the foundation for every visualization.",
  },
  {
    num: "02",
    title: "Choose Your Session",
    description: "Select competition, practice, or recovery. Answer a few guided questions specific to what you need right now.",
  },
  {
    num: "03",
    title: "AI Generates Your Script",
    description: "Our engine combines your profile, session inputs, sport-specific knowledge, and best practices into a personalized visualization script.",
  },
  {
    num: "04",
    title: "Listen & Perform",
    description: "Choose your voice, press play, and immerse yourself. Track your mental performance lift over time.",
  },
];

const HowItWorksSection = () => {
  return (
    <section className="py-24 md:py-32" id="how-it-works">
      <div className="container px-6">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <motion.h2
            className="font-display text-3xl md:text-5xl font-bold mb-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            How <span className="text-gradient-accent">VIZ</span> works
          </motion.h2>
          <motion.p
            className="text-muted-foreground text-lg"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            From profile to playback in minutes.
          </motion.p>
        </div>

        <div className="max-w-3xl mx-auto space-y-0">
          {steps.map((step, i) => (
            <motion.div
              key={step.num}
              className="relative flex gap-6 pb-12 last:pb-0"
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
            >
              {/* Vertical line */}
              {i < steps.length - 1 && (
                <div className="absolute left-6 top-14 bottom-0 w-px bg-gradient-to-b from-primary/40 to-transparent" />
              )}

              <div className="flex-shrink-0 w-12 h-12 rounded-full gradient-cta flex items-center justify-center">
                <span className="font-display font-bold text-primary-foreground text-sm">{step.num}</span>
              </div>

              <div className="pt-1">
                <h3 className="font-display text-xl font-semibold mb-1">{step.title}</h3>
                <p className="text-muted-foreground leading-relaxed">{step.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
